import React from 'react'
import './styles.scss'

export function KantonWappen(props) {
  // const filteredList = listKanton.filter(val => val.kanton === props.kanton)

  return (
    <>
      <div className='wappenWrapper'>
        <img
          src={require(`./imgs/${props.kantonWappen}.svg`)}
          alt=''
          className='ui fluid image'
        />
        <span
          className='totalSitze'
          style={{
            fontFamily: 'TamediaChart',
            display: 'inline-block',
            fontWeight: '800',
            whiteSpace: 'nowrap',
            paddingTop: '0.3em',
            lineHeight: '1.44em'
          }}
        >
          {props.totalSitze} Sitze <br />
        </span>
      
        <span
          className={props.sitzveraenderung === "" ? 'notvisible' : 'visible'}
          style={{
            fontFamily: 'TamediaChart',
            display: 'inline-block',
            fontWeight: '400',
            whiteSpace: 'nowrap',
            fontSize: '0.8rem',
            color: '#999999'
          }}
        >
          {props.sitzveraenderung} {props.sitzveraenderung > 1 ? 'Sitze' : 'Sitz'} (2019)
        </span>
      </div>
    </>
  )
}
